import {
    Col,
    Row
} from 'react-bootstrap';
import React from 'react';

// ✅ Type for StepItem props
export interface InstructionStepItemProps {
    number: number;
    title: string;
    description: React.ReactNode;
}

export const InstructionStepItem: React.FC<InstructionStepItemProps> = ({ number, title, description }) => {
    return (
        <Row className="mb-4 align-items-start">
            <Col xs="auto">
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: '#304768',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}
                >
                    {number}
                </div>
            </Col>
            <Col>
                <h4 className="mb-2">{title}</h4>
                <div>{description}</div>
                <hr />
            </Col>
        </Row>
    );
};